import {throttle} from '../modules/throttle';

/* вспомогательный модуль
 * Определяет видимость элемента в течение определенного времени
  * По истечении указанного времени вызывает callback
  *
  * param.box - блок, ивдимость которого отслеживаем
  * param.progressEl - блок  прогресса
  * param.callback - ф-я, которая вызывается если блок видим указанное время
  * param.time - время  в мс  в тчение которого будет виден блок
  * */

var checkVisibility = function(param){
    var box = param.box,
        progressEl = (param.progressEl || false),
        callback = (param.callback || false),
        stopTime = false,
        durTimeMs = (param.time || 30000),
        pastTimeMs = 0,
        startTimeMs = 0,
        checkVisibility = function(){
            var rect = box.getBoundingClientRect(),
                midY = rect.top + rect.height/2,
                midX = rect.left + rect.width/2;

            return (
                midY > 0 &&
                midX > 0 &&
                midY < (window.innerHeight || document.documentElement.clientHeight) &&
                midX < (window.innerWidth || document.documentElement.clientWidth)
            );
        },
        handleVisibilityChange = function(){
            if (document.hidden) {
                pause();
            } else {
                checkReload();
            }
        },
        checkReload = function(){
            if(checkVisibility()){
                if(!stopTime){
                    startTimeMs = Date.now();
                    var leftTimeMs = durTimeMs - pastTimeMs;
                    try {progressEl.style.cssText = 'width:100%;transition-duration:'+ leftTimeMs +'ms';} catch(e){}


                    //console.log('Старт интервала, оставшееся время показа', leftTimeMs);

                    stopTime = setTimeout(function(){
                        callback();
                        pastTimeMs = 0;
                        try {progressEl.style.cssText = 'width:0%;transition-duration:0ms';} catch(e){}
                        stopTime = false;
                        checkReload();
                        //console.log('Reload box', leftTimeMs);
                    }, leftTimeMs);
                }
            }
            else pause();
        },

        pause = function(){
            if(stopTime){
                clearTimeout(stopTime);
                stopTime = false;
                pastTimeMs += Date.now() - startTimeMs;
                try {progressEl.style.cssText = 'width:'+ pastTimeMs/durTimeMs*100 +'%;transition-duration:0ms';} catch(e){}
                //console.log('Приостановка pastTimeMs',  pastTimeMs);
            }
        },

        init = function(){
            throttle('scroll', checkReload);
            throttle('resize', checkReload);
            document.addEventListener('visibilityChange', handleVisibilityChange, false);
            if(!document.hidden) checkReload();
        };

    //
    if (document.readyState === "complete") {
        init();
    } else {
        window.addEventListener('load', init);
    }
}

export {checkVisibility};
